export default class TimeSpan {
    private milliseconds: number;

    constructor(milliseconds: number) {
        this.milliseconds = milliseconds;
    }

    static fromHours(hours: number): TimeSpan {
        return new TimeSpan(hours * 60 * 60 * 1000);
    }

    static fromMinutes(minutes: number): TimeSpan {
        return new TimeSpan(minutes * 60 * 1000);
    }

    static fromString(timespanStr: string): TimeSpan {
        // Expects format like "hh:mm:ss"
        const [hh, mm, ss] = timespanStr.split(':').map(Number);
        return new TimeSpan(((hh * 60 + mm) * 60 + ss) * 1000);
    }

    toString(): string {
        const totalSeconds = Math.floor(this.milliseconds / 1000);
        const hh = Math.floor(totalSeconds / 3600).toString().padStart(2, '0');
        const mm = Math.floor((totalSeconds % 3600) / 60).toString().padStart(2, '0');
        const ss = (totalSeconds % 60).toString().padStart(2, '0');
        return `${hh}:${mm}:${ss}`;
    }

    toJSON(): string {
        return this.toString();
    }

    getTotalMilliseconds(): number {
        return this.milliseconds;
    }
}